module.exports = __webpack_public_path__ + "img/logo1 (45).45da8f75.jpg";